<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.payments', 2),
                        href: meta.links.index,
                    },
                ]"
            >
            </SmartBreadcrumbs>
        </template>
        <form action="" @submit.prevent="submit">
            <GroupSelector :grade-levels="gradeLevels" :user-grade-levels="user_grade_levels">
                <template v-slot:default="{ filteredGradeLevels }">
                    <div
                        class="mb-2 flex space-x-2 items-center"
                        v-for="gradeLevel in filteredGradeLevels"
                        :key="gradeLevel.id"
                    >
                        <label class="flex space-x-1 items-center" v-for="group in gradeLevel.groups" :key="group.id">
                            <input
                                name="group_ids[]"
                                type="checkbox"
                                :value="group.id"
                                v-model="form.group_ids"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            <span
                                class="mr-2 no-pointer-events text-gray-700 bg-white hover:bg-gray-50 px-3 py-2 text-sm inline-flex items-center border border-gray-300 shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mr-2 no-pointer-events"
                            >
                                {{ group.name }}
                            </span>
                        </label>
                    </div>
                </template>
            </GroupSelector>

            <div class="flex justify-end space-x-2">
                <SubmitFormButton :button-text="$t('messages.continue')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GroupSelector from '@/components/GroupSelector.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        PanelPage,
        GroupSelector,
        SubmitFormButton,
    },
    layout: Layout,
    name: 'Show',
    props: ['gradeLevels', 'user_grade_levels', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                group_ids: [],
            }),
        };
    },
    methods: {
        submit() {
            this.form.get(this.meta.links.create);
        },
    },
};
</script>
